export const TEST_ID = 'triangleArrowIcon';
